import React, { useMemo } from 'react'

const IOS_SPINNER_SEGMENTS = 12

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // Keep background clean and white while loading
  backdropFilter: 'none',
  backgroundColor: '#ffffff',
  zIndex: 2000,
}

const PageLoadingComponent: React.FC = () => {
  const spinnerSegments = useMemo(
    () =>
      Array.from({ length: IOS_SPINNER_SEGMENTS }).map((_, index) => {
        const angle = (360 / IOS_SPINNER_SEGMENTS) * index
        const delay = -(1.2 - index * 0.1)
        return (
          <span
            key={index}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '3px',
              height: '10px',
              borderRadius: '2px',
              // Inherit color from parent so we can animate color at the container level
              backgroundColor: 'currentColor',
              transformOrigin: '1.5px 14px',
              transform: `rotate(${angle}deg) translate(-1.5px, -12px)`,
              opacity: 0.2,
              animation: 'iosSpinnerFade 1.2s linear infinite',
              animationDelay: `${delay}s`,
            }}
          />
        )
      }),
    [],
  )

  return (
    <>
      <style>
        {`
          @keyframes iosSpinnerFade {
            0% { opacity: 1; }
            100% { opacity: 0.15; }
          }

          /* Bright, fast-switching color cycle */
          @keyframes colorCycle {
            0% { color: #FF3B30; }      /* bright red */
            12.5% { color: #FF9500; }   /* orange */
            25% { color: #FFCC00; }     /* yellow */
            37.5% { color: #34C759; }   /* green */
            50% { color: #00C7BE; }     /* teal */
            62.5% { color: #007AFF; }   /* blue */
            75% { color: #5856D6; }     /* indigo */
            87.5% { color: #AF52DE; }   /* purple */
            100% { color: #FF2D55; }    /* pink */
          }
        `}
      </style>
      <div style={overlayStyle}>
        <div
          style={{
            position: 'relative',
            width: '20px',
            height: '20px',
            /* Fast discrete color jumps */
            animation: 'colorCycle 0.8s steps(8, end) infinite',
          }}
        >
          {spinnerSegments}
        </div>
      </div>
    </>
  )
}

export default PageLoadingComponent
